const indicadorInscricaoEstadual = {
  NAO_CONTRIBUINTE: 'Não contribuinte',
  CONTRIBUINTE: 'Contribuinte',
  CONTRIBUINTE_ISENTO: 'Contribuinte isento',
};

export default indicadorInscricaoEstadual;
